export default {
  "Studies available": "Қолжетімді зерттеулер",
  "Studies limit about":
    "Өңделетін зерттеулер саны шектеулі. Шекті көбейту үшін менеджерге немесе sales@3opinion.ai мекенжайына хабарласыңыз",
  "Studies limit reached":
    "Зерттеулерді өңдеу шегіне жетті. Шекті көбейту үшін менеджерге немесе sales@3opinion.ai мекенжайына хабарласыңыз",
  "Wait for upload": "Ағымдағы жүктеудің аяқталуын күтіңіз",
  Upload: "Жүктеу",
  directory: "Қаптаманы жүктеу",
  zip: "Файлдарды жүктеу",
  gender: "Жынысы, жасы",
  Name: "Атауы",
  Status: "Өңдеу күйі",
  studyDate: "Зерттеу күні",
  uploadDate: "Жүктеу күні",
  "Dicom count": "Суреттер саны",
  Action: "Әрекет",
  Delete: "Жою",
  "Delete confirm": "Зерттеуді жойғыңыз келетініне сенімдісіз бе?",
  "Delete confirm about": "Жою кезінде зерттеу өңдеу шегі өзгермейді",
  "No studies": "Зерттеулер жоқ",
  Search: "Іздеу",
  Cancel: "Бас тарту",
  "Study status none": "Басталмады",
  "Study status proccess": "Өңделуде",
  "Study status not_found": "Патология табылмады",
  "Study status found": "Патология табылды",
  Wait: "Күту",
  "Zip processed": "Сығу орын алуда",
  Done: "Дайын",
  "Success upload":
    "Файлдар сәтті жүктелді. Зерттеулер тізімінің жаңартылуын күтіңіз",
  "Upload error": "Сервер қолжетімсіз, кейінірек қайталап көріңіз",
  "Reach files size":
    "Жүктеу мүмкін емес. Файлдардың жалпы салмағы шектен асты",
  "Upload process": "Өңдеу",
  Yes: "Иә",
  No: "Жоқ",
  "Study in queue": "Кезекте",
  "Study in proccess": "Өңделуде",
  "Study not found": "Патология табылмады",
  "Study found": "Патология табылды",
  "Study error": "Өңдеу қатесі",
  "Study error about": "Жүктеу қатесі, зерттеуді қайта жүктеп көріңіз",
  patientID: "Пациент ID",
  male_short: "Е",
  female_short: "Ә",
  "Wait for anonimization": "Анонимизация",
  "Wait for loading": "Жүктелуде",
  "Studies title": "Зерттеулер тізімі | " + process.env.VUE_APP_INSTALL_NAME,
  "Error upload": "Жүктелген файлдар форматы талаптарға сай емес",
  undefined__error: "Жүктелген файлдар форматы талаптарға сай емес",
  good: "Жақсы",
  step0:
    "Сіз зерттеу файлдарының қаптамасын жүктей аласыз, қызмет оларды анонимизациялап жасанды интеллект көмегімен өңдейді",
  step1:
    "Сіздің зерттеулеріңіз жүктелуде, <br> бұл бірнеше минутқа созылуы мүмкін. <br><br> Жүктеу фондық режимде орындалады, бұл уақытта басқа зерттеулерді көруге болады.",
  step2:
    "Мұнда ИИ арқылы өңделген зерттеу пайда болады. <br><br> Өңдеу бірнеше минутқа созылуы мүмкін, ол фондық режимде жұмыс істейді. Осы уақытта басқа зерттеулерді көруге болады.",
  "Demo Upload text": "Тіркелгеннен кейін өз зерттеулеріңізді өңдей аласыз",
  Register: "Тіркелу",
  "Demo Banner Text":
    "Аккаунт жасап, ИИ қызметтері мен оқу курстарына толық қол жеткізіңіз",
  Okay: "Түсінікті",
  "Mobile Notification":
    "Сайтты мобильді құрылғыдан қараған кезде функциялар шектеулі.<br> Барлық функцияларға толық қол жеткізу үшін сайтты компьютерден ашыңыз.",
  "Studies limit Demo about":
    "Тіркелгеннен кейін жеке кабинетте өз зерттеулеріңізді өңдей аласыз",
  "Dicom count v2": "Қималар",
  prev: "Алдыңғы",
  next: "Келесі",
  "Files select": "Файлдар таңдалды",
  "Access files": "Қызмет талаптарына сәйкес келеді",
  "Access files about": "Олар ИИ талдау үшін серверге жүктеледі",
  "Skip files": "Сәйкес емес",
  "Tags values": "Тег мәндері",
  "Skip files about": "қызмет талаптарына сәйкес келмейді",
  Check: "Тексеру",
  "Status short": "Күйі",
  More: "Үлкейту",
  TagError: {
    tail: "<br><br> Басқа зерттеуді таңдаңыз немесе <a target='_blank' class='demo__underline demo__color--white' href='https://t.me/thirdopinion_support_bot'>техқолдауға жазыңыз</a>",
    not_exist: "<TAG> зерттеуде көрсетілмеген",
    some_error:
      "<TAG> зерттеуінің <TAG_VALUE> мәні <RULES> талаптарына сай емес",
    PatientsAge: "Пациент жасы 18-ден төмен",
    Modality: "Модалдылық",
    SliceThickness: "Қима қалыңдығы",
    BodyPartExamined: "Тексерілген дене бөлімі",
    StudyInstanceUID: "Зерттеу UID",
    SeriesInstanceUID: "Серия UID",
  },
};
